<template>
  <div class="main-content">
    <a-breadcrumb
      separator="/"
      class="margin-top-16"
    >
      <a-breadcrumb-item>
        <router-link
          :to="{name:'CostMaintain'}"
          class="cost-index"
        >
          {{ $t('message["105"]') }}
        </router-link>
      </a-breadcrumb-item>
      <a-breadcrumb-item>
        {{ $t('message["106"]') }}
      </a-breadcrumb-item>
    </a-breadcrumb>
    <div class="subtitle">
      {{ $t('message["105"]') }}
    </div>
    <a-select
      v-if="JSON.stringify(costIndexDataLocal)!=='{}'"
      class="month-date-div"
      :placeholder="selectTimePlace"
      :default-value="getPeriod"
      @change="handleChangeSelectGroup"
    >
      <a-select-opt-group
        v-for="(items,key) in costIndexDataLocal"
        :key="key"
        :label="key"
      >
        <a-select-option
          v-for="item in items"
          :key="item.period"
          :value="item.period"
        >
          {{ item.name }}
        </a-select-option>
      </a-select-opt-group>
    </a-select>
    <div>
      <a-table
        :data-source="dataSource"
        :columns="costDetailColumns"
        :pagination="false"
        size="middle"
        style="border-left:none"
      >
        <template
          slot="maintainContent"
          slot-scope="maintainContent"
        >
          <span v-if="maintainContent.isNewAdd">
            <a-cascader
              :options="options"
              :placeholder="selectPlaceholder"
              class="select-120"
              change-on-select
              @change="onChange"
            />
          </span>
          <span v-else>{{ maintainContent.str }}</span>
        </template>
        <template
          slot="maintainFrom"
          slot-scope="maintainFrom"
        >
          <span v-if="maintainFrom.isNewAdd">
            <a-cascader
              :options="optionsRange"
              :value="fromOriginValue"
              :placeholder="selectPlaceholder"
              class="select-120"
              change-on-select
              @change="onChangeFrom"
              @popupVisibleChange="handlePopupVisibleChange"
            />
          </span>
          <span v-else>{{ maintainFrom.str }}</span>
        </template>
        <template
          slot="realinquirynum"
          slot-scope="realinquirynum"
        >
          <span v-if="realinquirynum.isNewAdd">
            <a-input
              v-model="saveDatas.realinquirynum"
              :placeholder="enterPlaceholder"
              class="input-100"
              type="number"
              @keyup="handleKeyPress('realinquirynum')"
            />
          </span>
          <span v-else>{{ realinquirynum.str }}</span>
        </template>
        <template
          slot="netCost"
          slot-scope="netCost"
        >
          <span v-if="netCost.isNewAdd">
            <a-input
              v-model="saveDatas.netCost"
              :placeholder="enterPlaceholder"
              class="input-100"
              type="number"
              @keyup="handleKeyPress('netCost')"
            />
          </span>
          <span v-else>{{ netCost.str }}</span>
        </template>
        <template
          slot="grossCost"
          slot-scope="grossCost"
        >
          <span v-if="grossCost.isNewAdd">
            <a-input
              v-model="saveDatas.grossCost"
              :placeholder="enterPlaceholder"
              class="input-100"
              type="number"
              @keyup="handleKeyPress('grossCost')"
            />
          </span>
          <span v-else>{{ grossCost.str }}</span>
        </template>
        <template
          slot="operate"
          slot-scope="operate"
        >
          <span v-if="operate.isNewAdd">
            <a-button @click="saveCostMaintain">{{ operate.text }}</a-button>
          </span>
          <span v-else><a @click="handleSend(operate.id)">{{ operate.text }}</a></span>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a-popconfirm
            v-if="dataSource.length"
            title="Sure to delete?"
            @confirm="() => onDelete(record.key)"
          >
            <a href="javascript:;">Delete</a>
          </a-popconfirm>
        </template>
      </a-table>
      <a-button
        v-if="addBtnStatus"
        class="editable-add-btn"
        @click="handleAdd"
      >
        <a-icon
          type="plus"
          class="add-icon"
        />{{ $t('message["1346"]') }}
      </a-button>
    </div>
    <send-dialog :id="sendCostId" />
    <a-spin
      v-if="loadingContentDetail"
      class="spin-style"
    />
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import SendDialog from './SendDialog'
export default {
  components: {
    SendDialog
  },
  data () {
    return {
      options: [],
      sendCostId: null,
      defaultDate: null,
      costIndexDataLocal: {},
      dataSource: [],
      optionsRange: [],
      count: 2,
      fromOriginValue: [],
      saveDatas: {
        period: this.getPeriod,
        inquirynum: 0,
        roleid: 0,
        groupid: 0,
        userid: 0,
        realinquirynum: 0,
        grossCost: 0,
        netCost: 0,
        fieldkey: '',
        fieldval: ''
      }
    }
  },
  computed: {
    ...mapState('costMaintain/costIndexData', ['costIndexData']),
    ...mapState('costMaintain/costDetail', ['loadingContentDetail', 'costDetailColumns', 'inqueeryNum', 'fromDataLists', 'costDetail', 'costMaintainContentLists', 'addBtnStatus']),
    getPeriod () {
      return this.$route.query.period.toString()
    },
    year () {
      return this.$route.query.year
    },
    month () {
      return this.$route.query.month
    },
    enterPlaceholder () {
      return this.$t('message["751"]')
    },
    selectTimePlace () {
      return this.$t('message["874"]')
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    }
  },
  watch: {
    fromDataLists (val) {
      if (!val) {
        return
      }
      this.optionsRange = this.formateOptionsData(val)
    },
    costMaintainContentLists (val) {
      if (!val) {
        return
      }
      this.options = this.formateContentListDatas(val)
    },
    inqueeryNum: {
      handler (val) {
        if (!this.dataSource.length) return
        this.saveDatas.inquirynum = val
        let json = this.dataSource[this.dataSource.length - 1]
        json.inquirynum = val
        this.$set(this.dataSource, (this.dataSource.length - 1), json)
      },
      immediate: true
    },
    costIndexData (val) {
      if (!val) return
      let json = {}
      for (const key in val) {
        const data = val[key]
        data.map(value => {
          value.period = value.period.toString()
        })
        json[key] = data
      }
      this.costIndexDataLocal = json
      document.title = `${this.$t('message["105"]')}-${this.$store.state.baseinfo.projectname}-${this.$store.state.baseinfo.comname}`
    },
    costDetail (val) {
      if (val) {
        if (val.length === 0) {
          const newData = {
            key: new Date().getTime(),
            operate: {
              type: 'save',
              text: this.$t('message["21"]'),
              isNewAdd: true
            },
            grossCost: {
              str: 0,
              isNewAdd: true
            },
            netCost: {
              str: 0,
              isNewAdd: true
            },
            realinquirynum: {
              str: 0,
              isNewAdd: true
            },
            maintainFrom: {
              str: '',
              isNewAdd: true
            },
            maintainContent: {
              str: '',
              isNewAdd: true
            },
            inquirynum: 0,
            netCostPreInquiry: 0,
            grossCostPreInquiry: 0
          }
          this.dataSource = [newData]
          this.setAddBtnStatus(false)
          this.fetchGetInqueryNum(this.saveDatas)
          return
        }
        this.setAddBtnStatus(true)
        if (Array.isArray(val)) {
          val.map((value, index) => {
            value.key = value.addtime
            value.operate = {
              type: 'send',
              text: this.$t('message["274"]'),
              isNewAdd: false,
              id: value.id
            }
            if (Array.isArray(value.memberStr)) {
              let strMember = ''
              value.memberStr.map(vvs => {
                strMember += (vvs + '-')
              })
              strMember = strMember.substring(0, strMember.length - 1)
              value.maintainContent = { str: strMember, isNewAdd: false }
            }
            if (Array.isArray(value.fromStr)) {
              let strFrom = ''
              value.fromStr.map(vvs => {
                strFrom += (vvs + '-')
              })
              strFrom = strFrom.substring(0, strFrom.length - 1)
              value.maintainFrom = { str: strFrom, isNewAdd: false }
            }
            if (value.realinquirynum || value.realinquirynum * 1 === 0) {
              if (!value.realinquirynum.str && value.realinquirynum.str * 1 !== 0) {
                value.realinquirynum = { str: value.realinquirynum, isNewAdd: false }
              }
            }
            if (value.netCost || value.netCost * 1 === 0) {
              if (!value.netCost.str && value.netCost.str * 1 !== 0) {
                value.netCost = { str: value.netCost, isNewAdd: false }
              }
            }
            if (value.grossCost || value.grossCost * 1 === 0) {
              if (!value.grossCost.str && value.grossCost.str * 1 !== 0) {
                value.grossCost = { str: value.grossCost, isNewAdd: false }
              }
            }
          })
          this.dataSource = val
        }
      } else {
        const newData = {
          key: new Date().getTime(),
          operate: {
            type: 'save',
            text: this.$t('message["21"]'),
            isNewAdd: true
          },
          grossCost: {
            str: 0,
            isNewAdd: true
          },
          netCost: {
            str: 0,
            isNewAdd: true
          },
          realinquirynum: {
            str: 0,
            isNewAdd: true
          },
          maintainFrom: {
            str: '',
            isNewAdd: true
          },
          maintainContent: {
            str: '',
            isNewAdd: true
          },
          inquirynum: 0,
          netCostPreInquiry: 0,
          grossCostPreInquiry: 0
        }
        this.dataSource = [newData]
        this.setAddBtnStatus(false)
        this.fetchGetInqueryNum(this.saveDatas)
      }
    }
  },
  mounted () {
    this.saveDatas.period = this.getPeriod
    this.setInqueeryNum(0)
    this.fetchGetCostIndex()
    this.fetchGetMessageSource()
    this.fetchGetCostContentDatas()
    this.fetchGetCostDetail({ period: this.getPeriod })
  },
  methods: {
    ...mapMutations('costMaintain/costDetail', ['setAddBtnStatus', 'setSendDialogVisible', 'setInqueeryNum']),
    ...mapActions('costMaintain/costDetail', ['fetchGetCostDetail', 'fetchGetInqueryNum', 'fetchGetMessageSource', 'fetchGetCostContentDatas', 'fetchSaveCostMaintainDatas']),
    ...mapActions('costMaintain/costIndexData', ['fetchGetCostIndex']),
    onCellChange (key, dataIndex, value) {
      const dataSource = [...this.dataSource]
      const target = dataSource.find(item => item.key === key)
      if (target) {
        target[dataIndex] = value
        this.dataSource = dataSource
      }
    },
    handleChangeSelectGroup (val) {
      if (!val) {
        return
      }
      this.fetchGetCostDetail({ period: val })
    },
    saveCostMaintain () {
      this.fetchSaveCostMaintainDatas(this.saveDatas)
      this.fromOriginValue = []
      this.setInqueeryNum(0)
      this.saveDatas = {
        period: this.getPeriod,
        inquirynum: 0,
        roleid: 0,
        groupid: 0,
        userid: 0,
        realinquirynum: 0,
        grossCost: 0,
        netCost: 0,
        fieldkey: '',
        fieldval: ''
      }
    },
    handleSend (id) {
      this.sendCostId = id
      this.setSendDialogVisible(true)
    },
    onDelete (key) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter(item => item.key !== key)
    },
    handleKeyPress (flag) {
      if (flag === 'netCost') {
        if (this.saveDatas.realinquirynum * 1 === 0) {
          this.$set(this.saveDatas, 'netCostPreInquiry', 0)
        } else if (this.saveDatas.realinquirynum * 1 > 0) {
          this.$set(this.saveDatas, 'netCostPreInquiry', (this.saveDatas.netCost / this.saveDatas.realinquirynum).toFixed(2))
          this.dataSource[this.dataSource.length - 1].netCostPreInquiry = (this.saveDatas.netCost / this.saveDatas.realinquirynum).toFixed(2)
        } else {
          this.$set(this.saveDatas, 'netCostPreInquiry', 0)
        }
      } else if (flag === 'realinquirynum') {
        if (this.saveDatas.realinquirynum * 1 > 0) {
          if (this.saveDatas.netCost * 1 > 0) {
            this.$set(this.saveDatas, 'netCostPreInquiry', (this.saveDatas.netCost / this.saveDatas.realinquirynum).toFixed(2))
            this.dataSource[this.dataSource.length - 1].netCostPreInquiry = (this.saveDatas.netCost / this.saveDatas.realinquirynum).toFixed(2)
          }
          if (this.saveDatas.realinquirynum * 1 > 0) {
            this.$set(this.saveDatas, 'grossCostPreInquiry', (this.saveDatas.grossCost / this.saveDatas.realinquirynum).toFixed(2))
            this.dataSource[this.dataSource.length - 1].grossCostPreInquiry = (this.saveDatas.grossCost / this.saveDatas.realinquirynum).toFixed(2)
          }
        }
      } else {
        if (this.saveDatas.realinquirynum * 1 === 0) {
          this.$set(this.saveDatas, 'grossCostPreInquiry', 0)
        } else if (this.saveDatas.realinquirynum * 1 > 0) {
          this.$set(this.saveDatas, 'grossCostPreInquiry', (this.saveDatas.grossCost / this.saveDatas.realinquirynum).toFixed(2))
          this.dataSource[this.dataSource.length - 1].grossCostPreInquiry = (this.saveDatas.grossCost / this.saveDatas.realinquirynum).toFixed(2)
        } else {
          this.$set(this.saveDatas, 'grossCostPreInquiry', 0)
        }
      }
    },
    onChange (val) {
      if (Array.isArray(val)) {
        val.map(value => {
          const item = value.split('-')
          this.saveDatas[item[1]] = item[0]
        })
      }
      this.fetchGetInqueryNum(this.saveDatas)
    },
    onChangeFrom (val) {
      if (val.length === 1) {
        if (val[0] === -1) {
          this.saveDatas.fieldkey = ''
          this.saveDatas.fieldval = ''
        } else {
          this.saveDatas.fieldkey = val[0]
          this.saveDatas.fieldval = ''
        }
      } else if (val.length === 2) {
      } else if (val.length === 3) {
        this.saveDatas.fieldkey = val[1]
        this.saveDatas.fieldval = val[2]
      }
      this.fromOriginValue = val
      this.fetchGetInqueryNum(this.saveDatas)
    },
    handlePopupVisibleChange (val) {
      if (!val) {
        if (this.fromOriginValue.length === 2) {
          if (this.fromOriginValue[0] !== -1) {
            this.fromOriginValue = []
          }
        }
      }
    },
    formateContentListDatas (array) {
      let tempv = []
      array.map(value => {
        let json = {
          label: value.name,
          value: value.id + '-' + value.keyname,
          children: []
        }
        if (value.children) {
          value.children.map(vvs => {
            let json2 = {
              label: vvs.name,
              value: vvs.id + '-' + vvs.keyname,
              children: []
            }
            if (vvs.children) {
              vvs.children.map(item => {
                json2.children.push({
                  label: item.name,
                  value: item.id + '-' + item.keyname
                })
              })
            }
            json.children.push(json2)
          })
        }
        tempv.push(json)
      })
      return tempv
    },
    handleAdd () {
      this.setAddBtnStatus(false)
      const { count, dataSource } = this
      const newData = {
        key: new Date().getTime(),
        operate: {
          type: 'save',
          text: this.$t('message["21"]'),
          isNewAdd: true
        },
        grossCost: {
          str: 0,
          isNewAdd: true
        },
        netCost: {
          str: 0,
          isNewAdd: true
        },
        realinquirynum: {
          str: 0,
          isNewAdd: true
        },
        maintainFrom: {
          str: '',
          isNewAdd: true
        },
        maintainContent: {
          str: '',
          isNewAdd: true
        },
        inquirynum: 0,
        netCostPreInquiry: 0,
        grossCostPreInquiry: 0
      }
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
      this.fetchGetInqueryNum(this.saveDatas)
    },
    formateOptionsData (array) {
      let tempValue = []
      if (Array.isArray(array)) {
        array.map(value => {
          const json = {
            value: value.fieldkey,
            label: value.fieldname,
            children: []
          }
          if (value.child) {
            const secondArray = Object.values(value.child)
            secondArray.map(values => {
              const jsons = {
                label: values.fieldname,
                value: values.fieldkey,
                children: []
              }
              if (values.options) {
                for (const key in values.options) {
                  jsons.children.push({
                    label: values.options[key].name,
                    value: values.options[key].id
                  })
                }
              }
              json.children.push(jsons)
            })
          }
          tempValue.push(json)
        })
      }
      tempValue.unshift({
        label: this.$t('message["904"]'),
        value: -1,
        children: []
      })
      return tempValue
    }
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/css/statistic/style.scss';
.input-100 {
  width: 100px;
}
.select-120 {
  width: 120px;
}
.cost-index {
      color: #5077aa
    }
.editable-add-btn {
  margin-top: 24px;
  width: 72px;
  height: 32px;
  border-radius: 4px;
  margin-bottom: 40px;
  box-shadow: inset 0 2px 0 0 rgba(255, 255, 255, 0.5);
  border: solid 1px #ebebeb;
  background-color: #f5f5f5;
  color: #333333;
  .add-icon {
    margin-left: -4px;
  }
}
.month-date-div {
  margin-top: 16px;
  margin-bottom: 24px;
  .month-picker-style {
    width: 300px;
  }
}
</style>
